import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import { FormattedHTMLMessage } from 'component-utilities/intl';
import styles from './Forms.scss';

function FormErrorText(props) {
    const { error, field, attributes, values } = props;

    if (!error) {
        return <noscript />;
    }

    return (
        <span
            {...attributes}
            className={styles['form-error-text']}
            data-field={field}
            data-message={`${field}.${error}`}
        >
            <FormattedHTMLMessage id={error} values={values} />
        </span>
    );
}

FormErrorText.displayName = displayName('Forms/FormErrorText');

FormErrorText.propTypes = {
    field: PropTypes.string.isRequired,
    error: PropTypes.string,
    attributes: PropTypes.object,
    values: PropTypes.object,
};

FormErrorText.defaultProps = {
    error: '',
    attributes: {},
    values: {},
};

export default FormErrorText;
